var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaMp3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_mp3_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139294",
    "data-name": "\\uD328\\uC2A4 139294",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139295",
    "data-name": "\\uD328\\uC2A4 139295",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139296",
    "data-name": "\\uD328\\uC2A4 139296",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139297",
    "data-name": "\\uD328\\uC2A4 139297",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139298",
    "data-name": "\\uD328\\uC2A4 139298",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139299",
    "data-name": "\\uD328\\uC2A4 139299",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139300",
    "data-name": "\\uD328\\uC2A4 139300",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#a54af4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139301",
    "data-name": "\\uD328\\uC2A4 139301",
    d: "M34.459.055,11.694,6.688A1.369,1.369,0,0,0,10.709,8V24.6A7.249,7.249,0,1,0,14.5,30.971V12.322a.683.683,0,0,1,.493-.656L31.544,6.842a.684.684,0,0,1,.876.656V18.772a7.249,7.249,0,1,0,3.79,6.372V1.368A1.369,1.369,0,0,0,34.841,0,1.394,1.394,0,0,0,34.459.055Z",
    transform: "translate(20.865 35.237)",
    fill: "#a54af4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139375",
    "data-name": "\\uD328\\uC2A4 139375",
    d: "M10.343,10.591H8.1v-7.3L5.857,8.138H4.348L2.109,3.314v7.276H0V.207H2.55L5.175,5.726,7.793.207h2.55Zm4.882-3.535v3.535H12.951V.207h3.928a4.884,4.884,0,0,1,3.066.823,2.879,2.879,0,0,1,1.047,2.408,3.28,3.28,0,0,1-1.158,2.636,4.505,4.505,0,0,1-3.018.982ZM15.211,1.84V5.409h.606a3.736,3.736,0,0,0,2.264-.472,1.8,1.8,0,0,0,.555-1.45A1.467,1.467,0,0,0,18.1,2.26a3.668,3.668,0,0,0-2.112-.42Zm7.2,8.317V8.2h.22a6,6,0,0,0,2.956.9,2.822,2.822,0,0,0,1.7-.451,1.536,1.536,0,0,0,.613-1.32,1.274,1.274,0,0,0-.479-1.065,3.515,3.515,0,0,0-1.981-.376h-.606V4.327h.572q2.315,0,2.315-1.413a.993.993,0,0,0-.5-.9,2.7,2.7,0,0,0-1.413-.307,6.379,6.379,0,0,0-2.894.882h-.207V.655A9.6,9.6,0,0,1,26.081,0a4.962,4.962,0,0,1,2.9.7A2.188,2.188,0,0,1,29.96,2.57a2.3,2.3,0,0,1-.544,1.519,2.647,2.647,0,0,1-1.454.872v.1a2.948,2.948,0,0,1,1.647.81,2.211,2.211,0,0,1,.606,1.609A2.929,2.929,0,0,1,29.057,9.9a4.942,4.942,0,0,1-3.135.91A9.188,9.188,0,0,1,22.408,10.157Z",
    transform: "translate(7.602 9.026)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaMp3Icon);
export default __webpack_public_path__ + "static/media/minerva_mp3_icon.29f0ddb0e40beee33f58d50359d59879.svg";
export { ForwardRef as ReactComponent };